import styled from 'styled-components';

export const Wrapper = styled.div`
    display:flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const Content = styled.div`
    flex-grow:1;
    overflow-y:scroll;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: ${prop => (prop?.column ? 'column' : 'row')} ;
    padding: 0 4px;
    margin-top: 5px;
    .pl-20{
        padding-left: 20px;
    }

    .sub-label{
        padding-left: 8px;
        font-size: 0.8rem;
    }
`;

export const MLabel = styled.label`
    font-size: 1rem;
    color: #6c757d;
`
export const Line = styled.div`
    display: flex;
    flex-direction: ${prop => (prop?.column ? 'column' : 'row')} ;
`

export const Input = styled.input`
    width: ${prop => (prop?.width ? prop.width : 'auto')} ;
    margin-top: ${prop => (prop?.mtop ? prop.mtop : 'auto')} ;
    margin-left: 12px;
    margin-right: 12px;
    font-size: 1rem;
    padding: 2px 5px;
    
    border: 1px solid grey;
    border-radius: 3px;
    color: #000;
`
export const Button = styled.button`
    margin-left:3px;
    padding: 2px 10px;
    font-size: 1rem;
    border:1px solid transparent;
    border-color: var(--morienGreen);
    border-radius: 5px;
    background-color: var(--morienGreen);
    color: white;
    cursor: pointer;
    :active{
        background-color: #32cd32;
    }
`;
export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 12px 32px;

    button{
        padding: 8px 20px;
        font-size: 1rem;
        font-weight: bold;
    }

    .back {
        background-color: #7c7c7c;
        border-color: #7c7c7c;
    }
`;